import React from 'react';
import { CustomModal } from '@/components/Molecules';
import Image from 'next/image';
import elementsUrl from '@/public/images/elements.png';
import { Typography } from '@/components/Atoms';
import { useResponsive } from '@/hooks';

export interface LivePriceModalProps {
  visible: boolean;
  onClose: () => void;
}

const LivePriceModal: React.FunctionComponent<LivePriceModalProps> = ({ visible, onClose }) => {
  const { isDesktop1024 } = useResponsive();
  return (
    <CustomModal centered visible={visible} onClose={onClose} className='overflow-visible' bodyStyle={{ maxWidth: isDesktop1024 ? 500 : 700 }}>
      <div className='mt-[-100px] sm:mt-[-150px] text-center'>
        <Image src={elementsUrl} alt='element-url' />
      </div>
      <div className='text-center mt-[-30px] text-white mb-5 md:mb-10'>
        <Typography size='s28ToS18' className='mb-2' Component={'h5'} isBold>
          Exciting Things Are Coming! 🚀
        </Typography>
        <Typography size='s24ToS16'>
          Our new element exchange for trading game assets is currently under construction. Stay tuned for exclusive features and amazing trades,
          launching soon!
        </Typography>
      </div>
    </CustomModal>
  );
};

export default LivePriceModal;
